import React from 'react'
import { Link } from 'gatsby'
// Images
import categoryImg from '../../images/category/category_test.jpeg'
// Styles
import {
  CardItem,
  CategoryTitle,
  ImageOverlay,
  Wrapper,
} from './ProductCategory.styles'

const ProductCategory = category => {
  return (
    <Wrapper>
      <CardItem
        as={Link}
        backgroundimg={category?.image ?? categoryImg}
        data-qa={`category-${category.name}`}
        to={`/products/type/${category.url_key}`}
      >
        <ImageOverlay>
          <CategoryTitle>{category.name.toUpperCase()}</CategoryTitle>
        </ImageOverlay>
      </CardItem>
    </Wrapper>
  )
}

export default ProductCategory
